import React, { useState } from "react";
import "../css/user.css";
import { addTokens } from '../Utility/Mines/manageMinesFunctions';
import arrow from '../img/arrow.png';

function SuperAdminMine({ id, name, email, collaborators, tokens }) {
    const [tokenAmount, setTokenAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isManageMineVisible, setIsManageMineVisible] = useState(false);

    const handleAddTokens = async () => {
        setLoading(true);
        setError(null);
        try {
            await addTokens(id, tokenAmount);
            alert('Tokens added successfully!');
            window.location.reload(); // Reload the page after successful operation
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const toggleManageMine = () => {
        setIsManageMineVisible(!isManageMineVisible);
    };

    return (
        <>
            <div className="mine">
                <p id="Mine" className="textlink UserField"><b>Mine:</b> {name}</p>
                <p id="AdminMine" className="textlink UserField"><b>Admin:</b> {email}</p>
                <p id="CollaboratorsMine" className="textlink UserField"><b>Collaborators:</b> {collaborators}</p>
                <p id="tokensMine" className="textlink UserField"><b>Tokens:</b> {tokens}</p>
                <img
                    src={arrow}
                    alt="Manage Mine Area"
                    className={`arrowbutton ${isManageMineVisible ? 'rotated' : ''}`}
                    onClick={toggleManageMine}
                />
            </div>

            <div className={`ManageMine ${isManageMineVisible ? 'visible' : ''}`} id={id}>
                <div className="ManageMineButtonArea">
                    <input
                        type="number"
                        className="tokenInput"
                        value={tokenAmount}
                        onChange={(e) => setTokenAmount(Number(e.target.value))}
                        placeholder="Enter token amount"
                    />
                    <button
                        type="submit"
                        className="button buttonUser"
                        onClick={handleAddTokens}
                        disabled={loading}
                    >
                        {loading ? 'Adding...' : 'Add Tokens'}
                    </button>
                    {error && <p className="error">Error: {error}</p>}
                </div>
            </div>
        </>
    );
}

export default SuperAdminMine;
